<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  domain: String,
  fragment: String
});
</script>

<template>
  <Link
    class="text-primary-400 hover:text-primary-300 ml-1 underline"
    :href="route('domain-analysis.show', [domain]) + '#' + fragment"
    prefetch
  >
    {{
      $t('domain_score.partials.detailed_report.link_domain_analysis.analyze')
    }}
  </Link>
</template>
